export const InspectionDetailRouting = {
  path: "/inspectionDetail",
  name: "inspectionDetail",
  meta: { title: "巡检详情" },
  component: () => import(/* webpackChunkName: "join" */ "@/views/join/h5/inspection-detail/index.vue"),
  children: [],
};
